/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Stat_VenuesInputs */

const cs_settings_venues_stat_venues = /** @type {(inputs: Settings_Venues_Stat_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobočky`)
};

const en_settings_venues_stat_venues = /** @type {(inputs: Settings_Venues_Stat_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offices`)
};

/**
* | output |
* | --- |
* | "Offices" |
*
* @param {Settings_Venues_Stat_VenuesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_stat_venues = /** @type {((inputs?: Settings_Venues_Stat_VenuesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Stat_VenuesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_stat_venues(inputs)
	return cs_settings_venues_stat_venues(inputs)
});